<template>
    <div class="license container">
        <div class="background-img-container">
            <div class="background-image"></div>
        </div>
        <div class="contentSection">
            <div class="lol">
                <svg xmlns="http://www.w3.org/2000/svg" width="26.56" height="26.749" viewBox="0 0 26.56 26.749">
                    <g transform="translate(-141.28 -378.225)">
                        <g transform="translate(141.28 378.225)">
                            <path class="a"
                                d="M164.665,385.246A3.759,3.759,0,1,0,160.9,389a3.753,3.753,0,0,0,3.765-3.75m-14.693-6.986c-.5.193-.926.342-1.342.522a6.733,6.733,0,0,0-3.42,2.973,8.035,8.035,0,0,0-.861,2.947,25.07,25.07,0,0,0,.145,5.191c.167,1.737.324,3.473.45,5.212a13.776,13.776,0,0,1-.555,5.281,21.651,21.651,0,0,1-.872,2.018,1.967,1.967,0,0,0-.108.215.155.155,0,0,0,.027.141.151.151,0,0,0,.142-.005.859.859,0,0,0,.186-.153,7.818,7.818,0,0,1,4.472-2.152,17.252,17.252,0,0,1,4.869-.007c1.713.212,3.421.471,5.135.68a26.333,26.333,0,0,0,2.7.217,6.4,6.4,0,0,0,2.4-.354,3.214,3.214,0,0,0,1.921-1.838,6.586,6.586,0,0,0,.414-2.446.952.952,0,0,0-.033-.167c-.1.059-.186.1-.262.153a6.709,6.709,0,0,1-3.188,1.025,24.919,24.919,0,0,1-4.818-.208,33.679,33.679,0,0,0-4.793-.275,8.5,8.5,0,0,0-5.009,1.6c-.184.141-.355.3-.536.447a2.47,2.47,0,0,1-.219.149l-.059-.06a1.164,1.164,0,0,1,.119-.179,4.928,4.928,0,0,0,1.271-2.79,15.308,15.308,0,0,0,.071-3.8c-.116-1.39-.246-2.78-.333-4.171-.066-1.027-.113-2.058-.1-3.085a9.245,9.245,0,0,1,.791-3.838,6.04,6.04,0,0,1,3.831-3.223.564.564,0,0,1,.157-.031c1.235,0,2.47,0,3.719.048l-.387.111a7.587,7.587,0,0,0-2.6,1.237,5.605,5.605,0,0,0-2.059,3.365,14.316,14.316,0,0,0-.191,3.983c.044.777.124,1.552.168,2.328.049.866.107,1.734.1,2.6a6.909,6.909,0,0,1-.354,2.433,14.031,14.031,0,0,1-.669,1.366c-.044.089-.1.173-.145.26l.056.057a.93.93,0,0,0,.184-.1,5.34,5.34,0,0,1,3.215-1.342,21.152,21.152,0,0,1,4.26.085c1.175.115,2.351.235,3.53.266a9.284,9.284,0,0,0,2.153-.209,2.743,2.743,0,0,0,2.279-2.5,13.808,13.808,0,0,0,.057-1.579,1.569,1.569,0,0,0-.068-.324c-.112.068-.2.112-.271.168a5.071,5.071,0,0,1-3.118,1.078c-1.073,0-2.144-.049-3.214-.1a8.784,8.784,0,0,0-5.921,1.676,2.523,2.523,0,0,1-.234.142l-.06-.053a1.592,1.592,0,0,1,.13-.232,5.68,5.68,0,0,0,1.246-3.589c.018-1.052-.092-2.108-.126-3.163a12.627,12.627,0,0,1,.158-3.342,6,6,0,0,1,2.81-3.715c.2-.126.4-.236.6-.358a4.024,4.024,0,0,1,2.394-.618c1.242.059,2.489.014,3.734.015a3.905,3.905,0,0,1,3.888,3.883q0,9.475,0,18.948a3.884,3.884,0,0,1-3.893,3.9q-9.393,0-18.786,0a3.887,3.887,0,0,1-3.88-3.882V382.118a3.9,3.9,0,0,1,3.872-3.872q2.244,0,4.488,0c.085,0,.169.008.332.015"
                                transform="translate(-141.28 -378.225)" />
                        </g>
                    </g>
                </svg>
                <div class="contentSubtitle">{{ $t('loginScreen.subtitle') }}</div>
            </div>
            <div class="the-journey-logo">
                <svg xmlns="http://www.w3.org/2000/svg" width="203.116" height="45.643" viewBox="0 0 203.116 45.643">
                    <g transform="translate(-91.71 -201.6)">
                        <g transform="translate(91.71 204.814)">
                            <path class="a"
                                d="M165.985,205.47c-.264,0-26.535.359-35.967.568-8.76.194-22.887.221-31.327.237-2.073,0-3.8.008-5,.012-1.121,0-1.608.007-1.819.029-.027,0-.045,0-.053,0l0,.011c-.106.017-.106.044-.106.088s0,.068.106.086l0,.012.064,0c.24.024.812.027,2.18.036,1.435.009,3.481.017,5.921.027,8.421.034,21.147.086,30.034.24,6.8.118,35.676.478,35.967.482h0a.087.087,0,0,0,.064-.029.106.106,0,0,0,.027-.071v-1.619a.106.106,0,0,0-.027-.072.114.114,0,0,0-.065-.029"
                                transform="translate(-91.71 -205.469)" />
                            <path class="a"
                                d="M320.971,206.263l0-.012c-.009,0-.031,0-.064,0-.24-.025-.812-.028-2.18-.037-1.435-.009-3.482-.017-5.921-.027-8.421-.034-21.148-.086-30.035-.24-6.8-.118-35.675-.478-35.967-.482h0a.087.087,0,0,0-.064.029.106.106,0,0,0-.027.072v1.619a.106.106,0,0,0,.027.071.085.085,0,0,0,.064.03h0c.264,0,26.535-.359,35.967-.568,8.76-.194,22.887-.222,31.327-.238,2.073,0,3.8-.007,5-.012,1.121,0,1.608-.007,1.819-.028l.053,0,0-.011c.106-.017.106-.044.106-.087s0-.069-.106-.086"
                                transform="translate(-117.961 -205.469)" />
                            <path class="b"
                                d="M143.671,248.656c5.875,0,10.635-4.909,10.635-11.3a10.64,10.64,0,1,0-21.27,0c0,6.4,4.722,11.3,10.635,11.3m0-24.654a13.213,13.213,0,0,1,13.313,13.349,13.317,13.317,0,1,1-26.624,0A13.213,13.213,0,0,1,143.671,224"
                                transform="translate(-98.256 -208.608)" />
                        </g>
                        <path class="b"
                            d="M273.769,224.54h20.012v2.305H276.335v9.52H291.55v2.305H276.335v9.706H294.45v2.305H273.769Z"
                            transform="translate(-30.834 -3.885)" />
                        <g transform="translate(91.716 220.655)">
                            <path class="b"
                                d="M103.415,224.54v2.305h12.063l.086,6.762s-.086,1.609-.086,3.769c0,5.685-4.133,11.371-10.448,11.371-5.912,0-10.635-4.908-10.635-11.3,0-.065,0,0,0-.066h-2.68c0,.064,0,0,0,.066a13.218,13.218,0,1,0,26.412-.193V224.54Z"
                                transform="translate(-91.717 -224.54)" />
                            <path class="b"
                                d="M209.98,241.943V227.106h5.807c4.573,0,7.288,2.937,7.288,7.437,0,4.028-2.176,6.773-5.86,7.3q-.353.051-.722.075c-.207.013-.416.022-.631.022Zm9.213,2.1c.191-.061.38-.127.562-.2,3.553-1.409,5.7-4.843,5.7-9.34,0-5.912-3.756-9.965-9.557-9.965h-8.484v26.141h2.566v-6.135h5.7l7.741,6.089h4.15Z"
                                transform="translate(-111.312 -224.54)" />
                        </g>
                        <path class="b"
                            d="M258.074,224.54l-.011,14.221L240.43,224.592v-.05l0,0h-2.566V242.1h2.566V227.888l17.619,14.168.013,0v.023l.013.013v0h2.566V224.54Z"
                            transform="translate(-24.753 -3.885)" />
                        <g transform="translate(155.659 220.655)">
                            <path class="b"
                                d="M192.458,224.54v12.837c0,5.685-4.133,11.371-10.448,11.371-5.912,0-10.635-4.908-10.635-11.3,0-.065,0,0,0-.066h-.018V224.54H168.71v12.837h-.01c0,.064,0,0,0,.066a13.217,13.217,0,1,0,26.41-.193V224.54Z"
                                transform="translate(-168.698 -224.54)" />
                            <path class="a"
                                d="M244.888,255.065H255.6c.187,0,.289-.147.169-.243l-5.354-4.343a.3.3,0,0,0-.341,0l-5.354,4.343c-.12.1-.017.243.17.243"
                                transform="translate(-181.564 -228.924)" />
                        </g>
                        <path class="b"
                            d="M330.786,224.54h-3.147l-10.208,11.773L307.223,224.54h-3.146l11.781,13.588.286.329v12.288h2.566l.01-12.288.286-.329Z"
                            transform="translate(-35.967 -3.885)" />
                        <path class="b" d="M194.413,203.331h-2.5V201.6h7.026v1.73h-2.5v6.519h-2.019Z"
                            transform="translate(-16.97 0)" />
                        <path class="b" d="M210.2,201.6h2.019v3.3h3v-3.3h2.019v8.249h-2.019v-3.23h-3v3.23H210.2Z"
                            transform="translate(-20.068)" />
                        <path class="b"
                            d="M229.623,201.6h5.169v1.73h-3.15v1.5h2.514v1.731h-2.514v1.557h3.311v1.73h-5.33Z"
                            transform="translate(-23.357)" />
                    </g>
                </svg>
                <div class="text-center font-weight-bold beta">BETA</div>
            </div>
            <div class="card-content center-align pa-3">

                <div class="text-center">
                    <!-- <v-btn 
                    v-if="user && !user.active"
                    color="rgba(165, 216, 103, 1)" 
                    class="elevation-0 font-weight-bold"
                    :disabled="handleDisabled || noCreds"
                    :loading="loading"
                    @click="getLicense">
                    Purchase License
                    <span slot="loader">Redirecting...</span>
                    <span slot="loader" class="custom-loader">
                        <v-icon>cached</v-icon>
                    </span>
                    </v-btn> -->
                    <div v-if="user && !user.active" class="">
                        <v-btn color="rgba(165, 216, 103, 1)" class="elevation-0 font-weight-bold stripe"
                            :disabled="handleDisabled || noCreds || stripeInitiated" :loading="loading"
                            @click="submit">{{ $t('auth.license.purchase') }}</v-btn>
                    </div>
                    <v-alert v-if="feedback" border="start" color="#592892" density="compact"
                        class="font-weight-bold mb-1 mt-4">{{ feedback }}</v-alert>
                </div>

                <div class="journey-start-date mb-6 mt-8">{{ $t('auth.license.headline') }}</div>

                <div class="text-center">
                    {{ $t('auth.license.intro') }}
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase'
import db from '@/firebase/init'
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'
import axios from 'axios';
import { functionUrl } from '@/helpers/firebaseEnv'
import { localizedNamedLocation } from '@/helpers/localePath'

const PRICE_ID_CACHE_KEY = 'journey_stripe_price_id';

export default {
    name: 'License',
    components: {},
    data() {
        return {
            feedback: '',
            loader: null,
            loading: false,
            noCreds: false,
            nounce: null,
            stripeInitiated: false,
            lineItems: [],
            origin: window.location.origin,
        }
    },
    watch: {
        '$route.params': {
            handler: function(event) {
                // Handle payment cancelation
                if (event.action === 'c') {
                    this.stripeInitiated = false;
                    this.cancel(event);
                }

                // Handle successful payment
                if (event.action === 's') {
                    this.stripeInitiated = true;
                    this.checkout(event);
                }
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        ...mapState('UserData', ['user']),
        // ...mapState('AppData', ['churches']),
        ...mapGetters('AppData', ['churches', 'cid']),
        handleDisabled() {
            // checks to disable the purchase license button
            if(this.user) {
                return this.user.active || 
                        this.checkAuthorization(['superAdmin','admin']) || 
                        this.loading
            }
            return false
        },
        successURL() {
            return this.origin + '/license/s/'+this.nounce
        },
        cancelURL() {
            // return 'http://localhost:8080/license/c/'+this.nounce
            return this.origin + '/license/c/'+ Date.now()
        }
    },
    methods: {
        // async submit() {
        //     this.nounce = Math.ceil(Math.random() * 1000000);
        //     this.stripeInitiated = true;

        //     localStorage.nounce = this.nounce;

        //     const endpoint = 'https://us-central1-the-journey-perimeter.cloudfunctions.net/createStripeSession';
        //     const return_url = this.origin + '/license';

        //     const data = {
        //         success_url: return_url + '/s/' + this.nounce,
        //         cancel_url: return_url + '/c/' + Date.now(),
        //         line_items: this.lineItems,
        //         mode: 'payment',
        //         client_reference_id: this.nounce,
        //         customer_email: this.user.email,
        //     };

        //     try {
        //         const response = await axios.post(endpoint, data);
        //         const sessionId = response.data.id;

        //         this.sessionID = sessionId;
        //         this.$refs.checkoutRef.redirectToCheckout();
        //     } catch (error) {
        //         // Log error to Firestore
        //         this.$store.dispatch('AppData/logError', {
        //             message: 'Error creating Stripe session',
        //             stack: error.stack,
        //             timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        //             component: 'License.vue',
        //             function: 'submit',
        //             additionalInfo: { 
        //                 userId: this.user ? this.user.uid : 'unknown', 
        //                 userEmail: this.user ? this.user.email : 'unknown', 
        //                 sessionData: data 
        //             }
        //         });
        //         console.error('Error creating Stripe session:', error);
        //         this.feedback = 'An error occurred while initiating the payment process. Please try again.';
        //         this.stripeInitiated = false;
        //     }
        // },
        async submit() {
            this.stripeInitiated = true;

            if (!Array.isArray(this.lineItems) || this.lineItems.length === 0) {
                const loaded = await this.fetchPriceId();
                if (!loaded) {
                    this.feedback = this.$t('auth.license.pricingUnavailable');
                    this.stripeInitiated = false;
                    return;
                }
            }

            if (!this.user || !this.user.email) {
                this.feedback = this.$t('auth.license.noEmail');
                this.stripeInitiated = false;
                return;
            }

            const endpoint = functionUrl('createStripeSession');
            const return_url = this.origin + '/license';

            const data = {
                success_url: return_url + '/s/',   // Success case, no nounce needed
                cancel_url: return_url + '/c/',    // Cancel case, no nounce needed
                line_items: this.lineItems,
                mode: 'payment',
                client_reference_id: this.user.id || this.user.uid || this.user.email,
                customer_email: this.user.email,
            };

            try {
                const response = await axios.post(endpoint, data);
                const sessionUrl = response.data?.url
                if (sessionUrl) {
                    window.location.assign(sessionUrl)
                    return
                }

                this.feedback =
                    'We could not start checkout. Please try again or contact support.'
                this.stripeInitiated = false
            } catch (error) {
                const status = error?.response?.status || 'unknown';
                const responseData = error?.response?.data || null;
                let serverMessage = '';

                if (typeof responseData === 'string') {
                    serverMessage = responseData;
                } else if (responseData?.error?.message) {
                    serverMessage = responseData.error.message;
                } else if (responseData) {
                    try {
                        serverMessage = JSON.stringify(responseData);
                    } catch (e) {
                        serverMessage = 'Unknown server response';
                    }
                }

                this.$store.dispatch('AppData/logError', {
                    message: 'Error creating Stripe session',
                    stack: error.stack,
                    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                    component: 'License.vue',
                    function: 'submit',
                    additionalInfo: { 
                        userId: this.user ? this.user.uid : 'unknown', 
                        userEmail: this.user ? this.user.email : 'unknown',
                        status,
                        responseData,
                        sessionData: data,
                    }
                });
                console.error('Stripe session error:', status, responseData, error);
                this.feedback = serverMessage
                    ? `Payment error: ${serverMessage}`
                    : 'An error occurred while initiating the payment process. Please try again.';
                this.stripeInitiated = false;
            }
        },
        // async checkout(event) {
        //     if (localStorage.nounce && event.token == localStorage.nounce) {
        //         try {
        //             // await this.activateUser();
        //             this.$router.push({ name: 'Welcome' });
        //         } catch (error) {
        //             // Log error to Firestore
        //             this.$store.dispatch('AppData/logError', {
        //                 message: 'Error during activation',
        //                 stack: error.stack,
        //                 timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        //                 component: 'License.vue',
        //                 function: 'checkout',
        //                 additionalInfo: { 
        //                     userId: this.user ? this.user.uid : 'unknown', 
        //                     userEmail: this.user ? this.user.email : 'unknown', 
        //                 }
        //             });
        //             console.error('Error during activation:', error);
        //             this.feedback = 'An error occurred while updating your account. Please contact support.';
        //         }
        //     } else {
        //         // Log token mismatch
        //         this.$store.dispatch('AppData/logError', {
        //             message: 'Nounce mismatch during checkout',
        //             stack: null,
        //             timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        //             component: 'License.vue',
        //             function: 'checkout',
        //             additionalInfo: { 
        //                 eventToken: event.token, 
        //                 storedNounce: localStorage.nounce, 
        //                 userId: this.user ? this.user.uid : 'unknown', 
        //                 userEmail: this.user ? this.user.email : 'unknown', 
        //             }
        //         });
        //         console.log('Nounce mismatch:', event.token, localStorage.nounce);
        //         this.handleTokenMismatch();
        //     }
        // },
        postPurchaseDestination() {
            const hasCid = !!(this.user && this.user.cid) || !!this.cid
            return localizedNamedLocation(hasCid ? 'Welcome' : 'Home', this.$route)
        },
        async checkout() {
            // Since `nounce` is no longer used, we just need to handle the session completion
            try {
                this.$router.push(this.postPurchaseDestination());

                // Optionally, show a success message
                this.feedback = this.$t('auth.license.success');
            } catch (error) {
                // Log any routing issues or errors
                this.$store.dispatch('AppData/logError', {
                    message: 'Error during post-purchase navigation',
                    stack: error.stack,
                    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                    component: 'License.vue',
                    function: 'checkout',
                    additionalInfo: { 
                        userId: this.user ? this.user.uid : 'unknown',
                        userEmail: this.user ? this.user.email : 'unknown',
                    }
                });
                // console.error('Error during post-purchase navigation:', error);
                this.feedback = this.$t('auth.license.afterPurchaseError');
            }
        },
        async activateUser(retryCount = 3) {
            try {
                const theUserRef = db.collection('users').where('email', '==', this.user.email);
                const theUser = await theUserRef.get();

                for (const doc of theUser.docs) {
                    await db.collection('users').doc(doc.id).update({
                        active: true,
                        activated: Date.now(),
                    });
                }
                // Log successful activation
                this.$store.dispatch('AppData/logError', {
                    message: 'User successfully activated',
                    stack: null,
                    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                    component: 'License.vue',
                    function: 'activateUser',
                    additionalInfo: { 
                        userId: this.user ? this.user.uid : 'unknown', 
                        userEmail: this.user ? this.user.email : 'unknown', 
                    }
                });
                // console.log('User successfully activated');
            } catch (error) {
                if (retryCount > 0) {
                    this.$store.dispatch('AppData/logError', {
                        message: `Retrying activation, attempts left: ${retryCount - 1}`,
                        stack: null,
                        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                        component: 'License.vue',
                        function: 'activateUser',
                        additionalInfo: { 
                            retryCount: retryCount,
                            userId: this.user ? this.user.uid : 'unknown', 
                            userEmail: this.user ? this.user.email : 'unknown', 
                        }
                    });
                    // console.warn(`Retrying activation, attempts left: ${retryCount - 1}`);
                    await this.sleep(1000); // Wait 1 second before retrying
                    await this.activateUser(retryCount - 1);
                } else {
                    // Log activation failure after retries
                    this.$store.dispatch('AppData/logError', {
                        message: 'Failed to activate user after multiple attempts',
                        stack: error.stack,
                        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                        component: 'License.vue',
                        function: 'activateUser',
                        additionalInfo: { 
                            retryCount: retryCount,
                            userId: this.user ? this.user.uid : 'unknown', 
                            userEmail: this.user ? this.user.email : 'unknown', 
                        }
                    });
                    // console.error('Failed to activate user after multiple attempts', error);
                    this.feedback = this.$t('auth.license.activationFailed');
                }
            }
        },
        sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },
        handleTokenMismatch() {
            if (this.$route.path.includes('/s/')) {
                this.feedback = this.$t('auth.license.tokenIssue');
                // Optionally, you can enable the button again for other operations or just inform the user to contact support.
            } else {
                this.feedback = this.$t('auth.license.tokenMismatch');
            }
        },
        cancel() {
            this.feedback = this.$t('auth.license.canceled');
        },
        checkAuthorization(permissions) {
            const userRoles = this.$store.getters['UserData/getRoles'];
            if (permissions && userRoles) {
                const hasRole = permissions.filter(() =>
                    userRoles.some((role) => permissions.includes(role))
                );
                if (hasRole && hasRole.length > 0) {
                    return true;
                }
            }
            return false;
        },
        // async getLicense() {
        //     this.loader = 'loading';
        //     this.loading = true;

        //     let churchTitle = this.churches.length > 0 ? this.churches[0].churchtitle : 'No Church Title';

        //     if (this.user && this.churches.length > 0) {
        //         if (!this.user.cid || !this.user.email) {
        //             this.feedback = 'Something went wrong and we do not have your credentials. Try refreshing your browser, then log out and back in. If you continue to have problems please contact tech support.';
        //             this.loader = null;
        //             this.loading = false;
        //         } else {
        //             try {
        //                 const endpoint = 'https://us-central1-the-journey-perimeter.cloudfunctions.net/createStripeSession';
        //                 const data = {
        //                     success_url: window.location.origin + '/license/s/' + this.nounce,
        //                     cancel_url: window.location.origin + '/license/c/' + Date.now(),
        //                     line_items: this.lineItems,
        //                     mode: 'payment',
        //                     client_reference_id: this.user.cid,
        //                     customer_email: this.user.email,
        //                     allow_promotion_codes: true
        //                 };

        //                 const response = await axios.post(endpoint, data);
        //                 const sessionId = response.data.id;

        //                 const stripe = Stripe('pk_live_51OHAW9AUcZuRPCmEPut310FwzmpS9xm8ao143QwpmEviFbI7orbgiAZePex60aeRi1k1q9kfQhv6FjsZhoVJsH7300II4zlU9e');
        //                 await stripe.redirectToCheckout({ sessionId });
        //             } catch (error) {
        //                 console.error('Error creating Stripe session:', error);
        //                 this.feedback = 'An error occurred while initiating the payment process. Please try again.';
        //                 this.loader = null;
        //                 this.loading = false;
        //             }
        //         }
        //     } else {
        //         this.feedback = 'Something went wrong and we do not have your credentials. Try refreshing your browser, then log out and back in. If you continue to have problems please contact tech support.';
        //         this.loader = null;
        //         this.loading = false;
        //         this.noCreds = true;
        //     }
        // },
        isOfflineFirestoreError(error) {
            const code = error?.code || '';
            const message = error?.message || '';
            return code === 'unavailable' || message.toLowerCase().includes('offline');
        },
        getStoredPriceId() {
            try {
                return window.localStorage.getItem(PRICE_ID_CACHE_KEY) || '';
            } catch (e) {
                return '';
            }
        },
        getFallbackPriceId() {
            return process.env.VUE_APP_STRIPE_PRICE_ID || this.getStoredPriceId();
        },
        setLineItemsFromPriceId(priceId) {
            if (!priceId) {
                return false;
            }

            this.lineItems = [
                {
                    price: priceId,
                    quantity: 1,
                },
            ];

            try {
                window.localStorage.setItem(PRICE_ID_CACHE_KEY, priceId);
            } catch (e) {
                // Best-effort cache only.
            }

            return true;
        },
        logFetchPriceIdError(error, context = {}) {
            this.$store.dispatch('AppData/logError', {
                message: context.message || 'Error fetching price_id',
                stack: error?.stack || null,
                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                component: 'License.vue',
                function: 'fetchPriceId',
                additionalInfo: {
                    userId: this.user ? this.user.uid : 'unknown',
                    userEmail: this.user ? this.user.email : 'unknown',
                    ...context,
                },
            });
        },
        async fetchPriceId(retryCount = 0) {
            const maxRetries = 3;
            const priceRef = db.collection('settings').doc('price_id');

            const applyFromDoc = (doc) => {
                if (doc && doc.exists) {
                    return this.setLineItemsFromPriceId(doc.data().value);
                }
                return false;
            };

            try {
                if (applyFromDoc(await priceRef.get({ source: 'cache' }))) {
                    return true;
                }
            } catch (error) {
                // Cache miss is expected on first visit.
            }

            try {
                if (applyFromDoc(await priceRef.get({ source: 'server' }))) {
                    return true;
                }

                if (this.setLineItemsFromPriceId(this.getFallbackPriceId())) {
                    return true;
                }

                this.logFetchPriceIdError(new Error('price_id document not found'), {
                    message: 'price_id document not found',
                });
                return false;
            } catch (error) {
                if (this.setLineItemsFromPriceId(this.getFallbackPriceId())) {
                    return true;
                }

                if (this.isOfflineFirestoreError(error) && retryCount < maxRetries) {
                    await this.sleep(1000 * (retryCount + 1));
                    return this.fetchPriceId(retryCount + 1);
                }

                this.logFetchPriceIdError(error);
                return false;
            }
        },
        init() {
            this.fetchPriceId();

            const hasCid = !!(this.user && this.user.cid) || !!this.cid
            const returningFromStripe =
                this.$route.params.action === 's' || this.$route.params.action === 'c'
            if (
                this.user &&
                !hasCid &&
                !this.checkAuthorization(['superAdmin', 'admin']) &&
                !returningFromStripe
            ) {
                this.$router.push(localizedNamedLocation('Home', this.$route))
                return
            }

            if (this.user) {
                if (this.checkAuthorization(['superAdmin', 'admin']) || this.user.active) {
                    this.$router.push(this.postPurchaseDestination());
                }
            }
        },
    },
    created() {
        this.handleOnline = () => {
            if (!this.lineItems.length) {
                this.fetchPriceId();
            }
        };
        window.addEventListener('online', this.handleOnline);
        this.init();
    },
    beforeUnmount() {
        if (this.handleOnline) {
            window.removeEventListener('online', this.handleOnline);
        }
    },


}
</script>

<style scoped>
[v-cloak] {
    display: none;
}
.license h2 {
    font-size: .95em;
}
.license.container {
    max-width: 600px;
}
.license.container::-webkit-scrollbar,
.license .contentSection::-webkit-scrollbar {
  display: none;
}
.license.container .background-img-container {
    position: fixed;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}
.license.container .background-image {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: url(../../assets/mountains.jpg) no-repeat 50% 0;
    background-size: cover;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    filter: grayscale(100%) blur(0px);
}
.theme--dark .license.container .background-image {
    filter: grayscale(100%) blur(0px) invert(1);
}
.background-image:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255,255,255,.85);
}
.license .contentSection {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    top: 56px;
    overflow: scroll;
    left: 0;
    height: 100%;
    /* max-height: calc(100vh - 250px); */
}
.license .contentSubtitle {
    color: rgba(0,0,0,1);
    font-weight: 700;
    font-size: 15px;
    margin-top: 7px;
    margin-bottom: 20px;
}
.theme--dark .license .contentSubtitle {
    color: #ffffff;
}
.license .the-journey-logo {
    margin: 20px 0 20px;
}
.theme--dark .license .the-journey-logo svg path:not(.a) {
    fill: #ffffff;
}
.license .v-alert {
    margin: -1px auto;
}
.license .reenter-pin {
    text-align: center;
    color:#000;
}
.profile-creator-container {
    margin-top: 40px;
    margin-bottom: 50%;
    padding:0;
}
.license .journey-start-date,
.license .app-guide-title {
    text-transform: uppercase;
    font-weight: 700;
    text-align: center;
    font-size: 20px;
}
.license .journey-start-date {
    color: #a5d867;
}
.license .app-guide-icon-title {
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 700;
}
.license #app-guide-icon-grn {
    cursor: pointer;
}
.app-guide-toolbar .v-toolbar__content {
    padding: 4px 16px;
}
.license .user-guides-container {
    display: flex;
    justify-content: center;
}
@media only screen and (max-width: 767px) {
    .license.container {
        position: fixed;
        height: 100%;
    }
}
</style>